var _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickOn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 19.352,
    rx: 4,
    fill: "#1D4FAF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 19,
    height: 18.352,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 19.352,
    rx: 4,
    fill: "#1D4FAF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2638_39745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 15,
    height: 15
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2638_39745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01525 12.9471L6.21501 11.2201C6.0615 11.0728 5.86613 10.9992 5.62889 10.9992C5.39165 10.9992 5.19627 11.0728 5.04276 11.2201C4.88925 11.3674 4.8125 11.5548 4.8125 11.7824C4.8125 12.01 4.88925 12.1974 5.04276 12.3447L7.42913 14.634C7.59659 14.7947 7.79197 14.875 8.01525 14.875C8.23854 14.875 8.43391 14.7947 8.60138 14.634L15.9572 7.47049C16.1107 7.32322 16.1875 7.13579 16.1875 6.9082C16.1875 6.6806 16.1107 6.49317 15.9572 6.3459C15.8037 6.19863 15.6084 6.125 15.3711 6.125C15.1339 6.125 14.9385 6.19863 14.785 6.3459L8.01525 12.9471Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickOn1);
export default __webpack_public_path__ + "static/media/tick_on 1.e3f912a8f20b253728239bd46abbc828.svg";
export { ForwardRef as ReactComponent };